<template>
  <ul class="speakers-list">
    <li class="speaker-cell"
        v-for="(speaker, index) in speakers"
        v-bind:key="index"
        @click="openModal(index)">
      <img class="speaker-image" v-bind:src="speaker.img"/>
      <div class="speaker-name">{{ speaker.name }}</div>
      <div class="speaker-name-en">{{ speaker.name_en }}</div>
    </li>

    <modal
      :click-to-close="true"
      name="speaker-modal"
      :scrollable="true"
      height="auto"
      width="80%">
      <div class="container speaker-modal-wrapper">
        <button type="button"
                @click="closeModal"
                class="close modal-close-button"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="modal-speaker-header">
          <span class="modal-speaker-name">
            {{ selectedSpeaker ? selectedSpeaker.name: '' }}
          </span>
          <span class="modal-speaker-name-en">
            {{ selectedSpeaker ? selectedSpeaker.name_en: '' }}
          </span>
        </div>

        <div class="row">
          <div class="col-sm-8 col-md-4 col-lg-3">
            <img class="modal-speaker-image"
                 v-bind:src="selectedSpeaker ? selectedSpeaker.img: ''"/>
          </div>

          <div class="col-sm-10 col-md-8 col-lg-9">
            <div class="modal-speaker-detail"
                 v-html="selectedSpeaker ? selectedSpeaker.detail: ''">
            </div>
          </div>
        </div>

        <div class="modal-speaker-youtube" v-if="selectedSpeaker && selectedSpeaker.youtube">
          <iframe
            v-bind:src="'https://www.youtube.com/embed/' + selectedSpeaker.youtube"
            frameborder="0" allowfullscreen>
          </iframe>
        </div>
      </div>
    </modal>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SpeakerList',
  props: ['speakers'],
  computed: {
    ...mapGetters(['selectedSpeaker']),
  },
  methods: {
    openModal(index) {
      this.$store.commit('setSelectedSpeaker', this.speakers[index]);
      this.$modal.show('speaker-modal');
    },
    closeModal() {
      this.$modal.hide('speaker-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/global";

.speakers-list {
  list-style: none;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 4px 24px;
  margin: 0;

  @include media-breakpoint-down(md) {
    padding: 4px 16px;
  }

  @include media-breakpoint-down(sm) {
    padding: 4px 8px;
  }

  .speaker-cell {
    border: solid 1px #b4b4b4;
    margin: 12px;
    padding: 12px;
    width: 30%;

    @include media-breakpoint-down(md) {
      margin: 12px;
      padding: 8px;
      width: 46%;
    }

    @include media-breakpoint-down(sm) {
      margin: 4px;
      padding: 2px;
      width: 46%;
    }
  }

  .speaker-cell:hover {
    opacity: 0.9;
    background: darken($brand-body-bg, 4);
  }

  .speaker-image {
    width: 100%;
  }

  .speaker-name {
    font-size: 20px;
    font-weight: bold;
    color: $brand-black;
    margin: 8px 4px 0 6px;

    @include media-breakpoint-down(md) {
      font-size: 18px;
      margin: 8px 4px 0 6px;
    }

    @include media-breakpoint-down(sm) {
      font-size: 16px;
      margin: 8px 4px 0 6px;
    }
  }

  .speaker-name-en {
    font-size: 17px;
    font-weight: bold;
    color: $brand-primary;
    margin: 0 4px 0 6px;

    @include media-breakpoint-down(md) {
      font-size: 15px;
      margin: 0 4px 4px 6px;
    }

    @include media-breakpoint-down(sm) {
      font-size: 13px;
      margin: 0 4px 4px 6px;
    }
  }
}

.speaker-modal-wrapper {
  font-family: $font-primary;
}

.modal-close-button {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 32px;

  span {
    padding: 8px;
  }
}

.modal-speaker-header {
  padding: 12px;

  @include media-breakpoint-down(md) {
    padding: 8px;
  }

  @include media-breakpoint-down(sm) {
    padding: 6px;
  }
}

.modal-speaker-name {
  font-size: 24px;
  font-weight: bold;
  color: $brand-black;
  margin: 0 2px 0 4px;

  @include media-breakpoint-down(md) {
    font-size: 20px;
    margin-left: 2px;
  }

  @include media-breakpoint-down(sm) {
    font-size: 18px;
    margin-left: 0;
  }
}

.modal-speaker-name-en {
  font-size: 20px;
  font-weight: bold;
  color: $brand-primary;
  margin: 0 4px 0 4px;

  @include media-breakpoint-down(md) {
    font-size: 18px;
  }

  @include media-breakpoint-down(sm) {
    font-size: 16px;
  }
}

.modal-speaker-image {
  width: 100%;
  margin: 4px 2px 24px 4px;

  @include media-breakpoint-down(sm) {
    width: 80%;
    margin: 8px 10% 16px 10%;
  }
}

.modal-speaker-detail {
  margin: 4px 6px 24px 2px;
  color: $brand-darker;
}

.modal-speaker-youtube {
  position: relative;
  width: 100%;
  padding-top: 56%;
  margin-bottom: 16px;

  iframe {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/SpeakerList.vue